import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MobileMenu = ({ menuOpen, setMenuOpen, whoOpen, setWhoOpen, location, isDemoPage }) => {
    const { t } = useTranslation();

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-40 transition-opacity z-40"
                onClick={() => setMenuOpen(false)}
            />

            {/* Drawer */}
            <div
                className={`fixed top-0 right-0 h-full w-64 bg-white shadow-xl transform transition-transform duration-300 z-50  ${menuOpen ? "translate-x-0" : "translate-x-full"
                    }`}
            >
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b">
                    <span className="font-bold text-lg">{t('nav.menu')}</span>
                    <button onClick={() => setMenuOpen(false)} className="text-2xl font-bold">
                        ×
                    </button>
                </div>

                {/* Links */}
                <div className="flex flex-col p-4 space-y-4">
                    <NavLink
                        to="/"
                        end
                        onClick={() => setMenuOpen(false)}
                        className={({ isActive }) => isActive ? "font-semibold text-[#6712FF]" : "text-gray-700"}
                    >{t('nav.home')}</NavLink>

                    {/* Who We Are Accordion */}
                    <button
                        onClick={() => setWhoOpen(!whoOpen)}
                        className={`w-full text-left font-medium flex justify-between items-center ${
                            location.pathname === "/our-story" || location.pathname === "/about-byg"
                                ? "text-[#6712FF] font-semibold"
                                : "text-gray-700"
                        }`}
                    >
                        {t('nav.whoWeAre')}
                        <span className={`ml-2 transition-transform duration-300 ${whoOpen ? "rotate-180" : "rotate-0"}`}>
                            ▼
                        </span>
                    </button>

                    {whoOpen && (
                        <div className="ml-4 mt-2 flex flex-col space-y-2">
                            <NavLink
                                to="/our-story"
                                onClick={() => setMenuOpen(false)}
                                className={({ isActive }) => isActive ? "font-semibold text-[#6712FF]" : "text-gray-700"}
                            >{t('nav.ourStory')}</NavLink>
                            <NavLink
                                to="/about-byg"
                                onClick={() => setMenuOpen(false)}
                                className={({ isActive }) => isActive ? "font-semibold text-[#6712FF]" : "text-gray-700"}
                            >{t('nav.aboutByg')}</NavLink>
                        </div>
                    )}

                    {/* Other Links */}
                    <NavLink
                        to="/blogs"
                        onClick={() => setMenuOpen(false)}
                        className={({ isActive }) => isActive ? "font-semibold text-[#6712FF]" : "text-gray-700"}
                    >{t('nav.blog')}</NavLink>
                    <NavLink
                        to="/demo"
                        onClick={() => setMenuOpen(false)}
                        className={({ isActive }) => isActive ? "font-semibold text-[#6712FF]" : "text-gray-700"}
                    >{t('nav.bookDemo')}</NavLink>


                </div>
            </div>
        </>
    );
};

export default MobileMenu;
